export default {
  awaitingReview: 'Pending', // Verification is awaiting a review.
  pendingChange: 'Requested Change', // Verification has a pending change.
  skipped: 'Skipped', // Verification has been approved.
  complete: 'Complete', // The ticket is closed.
};



// WEBPACK FOOTER //
// ./src/utils/verificationStatusConstants.js